import React from 'react';
import classes from './SubPO.module.scss';

interface Props {
  data: any;
}

const SubPO = ({ data }: Props) => {
  return (
    <div className={classes.wrapper}>
      <ul>
        <li>
          <span>PO # :</span>
          <span>{data?.poNo}</span>
        </li>
        <li>
          <span>PO Qty. :</span>
          <span>{data?.orderQty}</span>
        </li>
        <li>
          <span>PO # of Cartons :</span>
          <span>{data?.cartonsNo}</span>
        </li>
        <li>
          <span>Customer Name :</span>
          <span>{data?.clientName}</span>
        </li>
        <li>
          <span>Customer PO # :</span>
          <span>{data?.clientPONo}</span>
        </li>
      </ul>
    </div>
  );
};

export default SubPO;
